import { BACKORDER_LOADED, BACKORDER_RESET } from '../constants/actionTypes'
import dataState from './initialState/dataState'

export default function BackorderMissingParcelsReducer(state = dataState, action) {
    switch (action.type) {
        case BACKORDER_LOADED:
            return {
                ...state,
                nonVerifiedParcels: action.nonVerifiedParcels,
                backorderLoaded: true,
            }

        case BACKORDER_RESET:
            return dataState

        default:
            return state
    }
}
